// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1647":"fec77224","7492":"13d108d2"}[chunkId] || chunkId) + "." + {"803":"527867b367fd4785","1647":"af8daf4a3a27eead","3409":"5ec00c1e82acd35f","6521":"7ab641b94d932c03","7130":"44a651edcea28471","7492":"3af8e126b5c5fec9"}[chunkId] + ".js";
};